export const PANCHANG_EVENT_TYPES = {
  EKADASHI: 'ekadashi',
  PURNIMA: 'purnima',
  AMAVASYA: 'amavasya',
  FESTIVAL: 'festival',
  AUSPICIOUS: 'auspicious'
};

export const PANCHANG_EVENT_META = {
  [PANCHANG_EVENT_TYPES.EKADASHI]: {
    label: 'Ekadashi',
    badgeClass: 'bg-amber-100 text-amber-800 border-amber-200',
    dotClass: 'bg-amber-500'
  },
  [PANCHANG_EVENT_TYPES.PURNIMA]: {
    label: 'Purnima',
    badgeClass: 'bg-sky-100 text-sky-800 border-sky-200',
    dotClass: 'bg-sky-500'
  },
  [PANCHANG_EVENT_TYPES.AMAVASYA]: {
    label: 'Amavasya',
    badgeClass: 'bg-slate-100 text-slate-800 border-slate-200',
    dotClass: 'bg-slate-500'
  },
  [PANCHANG_EVENT_TYPES.FESTIVAL]: {
    label: 'Festival',
    badgeClass: 'bg-rose-100 text-rose-800 border-rose-200',
    dotClass: 'bg-rose-500'
  },
  [PANCHANG_EVENT_TYPES.AUSPICIOUS]: {
    label: 'Auspicious',
    badgeClass: 'bg-emerald-100 text-emerald-800 border-emerald-200',
    dotClass: 'bg-emerald-500'
  }
};

export const PANCHANG_SECTION_COPY = {
  title: 'Panchang Highlights',
  subtitle: 'Track key tithis and important occasions for your month before booking spiritual services.',
  cityNoticePrefix: 'Timings may vary slightly by location',
  todayCardTitle: 'Today in Panchang',
  monthlyCardTitle: 'Important Dates This Month'
};
